var w_modal = {

  init: function() {

    /**
     * Stop video embeds (iframes) from playing on modal close
     */
    $( '.modal' ).on( 'hidden.bs.modal', function() {
      iframe = $( this ).find( 'iframe' );

      if ( iframe.length ) {
        iframe.attr( 'src', iframe.attr( 'src' ) );
      }

    } );

  }

};
